var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" }),
    React.createElement("path", { d: "M9.574 18.118a.97.97 0 0 0 1.112-.014l.05-.037A15.964 15.964 0 0 0 16.61 10H3.375a15.392 15.392 0 0 0 5.97 7.961l.229.157z", fill: "#424242" }),
    React.createElement("ellipse", { cx: "10", cy: "7.75", rx: "7", ry: "6.75", fill: "#424242" }),
    React.createElement("circle", { cx: "10", cy: "8", r: "3", fill: "#fff" })
  );
});